"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getParentGCPId = exports.getGeoTree = exports.getGeoId = exports.getEventGenre = exports.gcpTree = exports.categories = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _consts = require("./consts");
var _staticCategory;
var categories = {
  CONCERT: 'concert',
  SPORTS: 'sports',
  THEATER: 'theater',
  OTHER: 'other'
};
exports.categories = categories;
var staticCategory = (_staticCategory = {}, (0, _defineProperty2["default"])(_staticCategory, categories.CONCERT, 1), (0, _defineProperty2["default"])(_staticCategory, categories.SPORTS, 28), (0, _defineProperty2["default"])(_staticCategory, categories.THEATER, 174), _staticCategory);
var arrayTree = function arrayTree(values) {
  var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  if (values && values.length) {
    var validValues = values.filter(function () {
      var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return typeof val.id !== 'undefined';
    });
    if (validValues && validValues.length) {
      return validValues.map(function (val) {
        return "".concat(prefix).concat(val === null || val === void 0 ? void 0 : val.id);
      }).join('/');
    }
  }
  return null;
};

/**
 * Returns the parent GCP id. It could be performer, grouping or category
 * @param {object} ancestors the ancestors which has categories, groups and performers
 * @returns the parent element id. It would be the first performer if there are several, if not the first grouping else the first category. If there are no ancestors, it will return null
 */
var getParentGCPId = function getParentGCPId(ancestors) {
  var _ref = ancestors || {},
    categories = _ref.categories,
    groupings = _ref.groupings,
    performers = _ref.performers;
  if (performers && performers.length) {
    return performers[0].id || null;
  }
  if (groupings && groupings.length) {
    return groupings[0].id || null;
  }
  if (categories && categories.length) {
    return categories[0].id || null;
  }
  return null;
};

/**
 * Concatenates the ancestors of the event, joined by a /
 * @example
 * /2/14/7834/
 *
 * @param {object} ancestors the ancestors which has categories, groups and performers
 * @returns a string with the joined ancestors
 */
exports.getParentGCPId = getParentGCPId;
var gcpTree = function gcpTree(ancestors) {
  var _ref2 = ancestors || {},
    categories = _ref2.categories,
    groupings = _ref2.groupings,
    performers = _ref2.performers;
  var categoriesTree = arrayTree(categories || [], _consts.GCP_TREE_PREFIXES.CATEGORY);
  var groupingsTree = arrayTree(groupings || [], _consts.GCP_TREE_PREFIXES.GROUPING);
  var performersTree = arrayTree(performers || [], _consts.GCP_TREE_PREFIXES.PERFORMER);
  var tree = [categoriesTree, groupingsTree, performersTree].filter(function (item) {
    return !!item;
  }).join('/');
  if (tree.length) {
    return "/".concat(tree, "/");
  }
  return '/';
};

/**
 *  If the given category matches one of the main genres, it resturns it's name. If not, it returns 'other'
 *
 * @param {string|number} categoryId the category Id
 * @returns the matching genre (concerts, sports, theater) or other if there is no match
 */
exports.gcpTree = gcpTree;
var getEventGenre = function getEventGenre(categoryId) {
  return Object.keys(staticCategory).find(function (key) {
    return staticCategory[key].toString() === (categoryId === null || categoryId === void 0 ? void 0 : categoryId.toString());
  }) || categories.OTHER;
};

/**
 **
 * Checks whether the passed geographies parameter is a populated array
 * @param geographies
 * @returns {boolean}
 */
exports.getEventGenre = getEventGenre;
var isValidGeographiesAncestor = function isValidGeographiesAncestor(geographies) {
  return geographies && Array.isArray(geographies) && geographies.length;
};

/**
 **
 * Gets the ID of the closest geography ancestors passed or null if something goes wrong
 * @param {object} ancestors with a geographies property, expected to be an array
 * @returns {number|null} the id of the last geography passed in the array or null otherwise
 */
var getGeoId = function getGeoId(_ref3) {
  var geographies = _ref3.geographies;
  if (!isValidGeographiesAncestor(geographies)) {
    return null;
  }
  return geographies[geographies.length - 1].id || null;
};

/**
 **
 * Concatenates the geography ancestors of the event, joined by a '/' in the order they come (supposedly from the more generic to the more specific)
 * @example
 * /X/YY/ZZZZ/  ->   /Spain/Comunidad de Madrid/Getafe/
 * @param {object} ancestors with a geographies property
 * @returns {string} All the joined ancestors, '/' by default
 */
exports.getGeoId = getGeoId;
var getGeoTree = function getGeoTree(_ref4) {
  var _ref4$geographies = _ref4.geographies,
    geographies = _ref4$geographies === void 0 ? [] : _ref4$geographies;
  if (!isValidGeographiesAncestor(geographies)) {
    return '/';
  }
  return geographies.reduce(function (acc, geoItem) {
    return geoItem.id ? "".concat(acc).concat(geoItem.id, "/") : acc;
  }, '/');
};
exports.getGeoTree = getGeoTree;